// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'

import { CurrencyInput } from '../'

import { showAsCurrency } from '../../utils'


export const AmountDetail = ({ label, value, onChange, readOnly }) => (
  <div className='slds-grid slds-m-bottom_xx-small'>
    <div className='slds-m-top_xx-small u-font-size-larger slds-size_1-of-2' >
      {label}
    </div>
    <div className='slds-size_1-of-2 slds-grid'>
      {readOnly
        ? showAsCurrency('R', value)
        : <CurrencyInput
            value={value}
            placeholder='Consolidation loan amount'
            onChange={onChange}
            maxWidth={100}
          />
      }
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/creditapplication-info/AmountDetail.js